const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");

function MemeCard(attributes) {
  let { meme } = attributes;
  const __1c = []; const __1a = {}; __1a['class'] = 'card mb-4 shadow-sm'; __1a['style'] = ({ minWidth: '200px' });
    const __2c = []; const __2a = {}; __2a['class'] = 'card-header';
      const __3c = []; const __3a = {}; __3a['class'] = 'my-0 font-weight-normal'; const __4 = meme.name; Array.isArray(__4) ? __3c.push(...__4) : __3c.push(__4); const __3 = blop.h('h4', __3a, __3c); __2c.push(__3);
     const __2 = blop.h('div', __2a, __2c); __1c.push(__2);
    const __5c = []; const __5a = {}; __5a['class'] = 'card-body';
      const __6c = []; const __6a = {}; __6a['src'] = meme.url; __6a['style'] = ({ width: '100%' }); const __6 = blop.h('img', __6a, __6c); __5c.push(__6);
     const __5 = blop.h('div', __5a, __5c); __1c.push(__5);
   const __1 = blop.h('div', __1a, __1c); return __1;
};
module.exports = { MemeCard };
